__turbopack_context__.v({
  "className": "cinzel_8da67ebb-module__whUJta__className",
});
